function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { leftChevronIcon, rightChevronIcon } from '@lululemon/ecom-pattern-library-icons';
import Icon from '../../icons';
require("./carousel-button.css");
var styles = {
  "carouselArrows": "carouselArrows-1eOub",
  "carouselArrowsRight": "carouselArrowsRight-1NmqL",
  "carouselArrowsLeft": "carouselArrowsLeft-3IBsK"
};
var CarouselButton = _ref => {
  var {
    direction,
    disableKeyboardNavigation,
    className,
    onClick,
    disabled,
    style
  } = _ref;
  var left = direction === 'left';
  var labelText = left ? 'Previous Slide' : 'Next Slide';
  var accessibilityProps = disableKeyboardNavigation ? {
    tabIndex: '-1',
    'aria-hidden': 'true'
  } : {
    'aria-label': labelText
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: cs('lll-text-primary', styles.carouselArrows, {
      [styles.carouselArrowsRight]: !left,
      [styles.carouselArrowsLeft]: left
    }, className),
    "data-testid": "carousel-button-".concat(direction)
  }, accessibilityProps, {
    onClick: onClick,
    disabled: disabled,
    style: style
  }), /*#__PURE__*/React.createElement(Icon, {
    content: left ? leftChevronIcon : rightChevronIcon
  }));
};
CarouselButton.propTypes = {
  direction: PropTypes.string,
  disabled: PropTypes.bool,
  disableKeyboardNavigation: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
};
CarouselButton.defaultProps = {
  direction: 'left',
  disabled: false,
  disableKeyboardNavigation: false,
  className: null,
  onClick: null,
  style: undefined
};
export default CarouselButton;